import { ReactNode } from 'react';
import View from '../common/View';
import Text from '../common/Text';
import { useLanguage } from '../hooks/useLanguage';

interface BaseTemplateProps {
  children: ReactNode;
  title?: string;
  subtitle?: string;
  showLogo?: boolean;
}

export default function BaseTemplate({
  children,
  title,
  subtitle,
  showLogo = true,
}: BaseTemplateProps) {
  const { LogoType } = useLanguage();

  return (
    <View className="base-template">
      {showLogo && (
        <View className="logo-container">
          <LogoType />
        </View>
      )}

      {(title || subtitle) && (
        <View className="header-content">
          {title && (
            <Text variant="h1" className="page-title">
              {title}
            </Text>
          )}
          {subtitle && (
            <Text variant="body" className="page-subtitle">
              {subtitle}
            </Text>
          )}
        </View>
      )}

      <View className="main-content">{children}</View>
    </View>
  );
}
